<script setup lang="ts">
/**
 * PageHeader (§03) — shared main-view header: eyebrow + H1 + sub on the left,
 * an optional action slot on the right. Reused across Today and later views.
 */
defineProps<{ eyebrow?: string; title: string; sub?: string }>()
</script>

<template>
  <div class="pagehdr">
    <div class="pagehdr__text">
      <div v-if="eyebrow" class="pagehdr__eyebrow">{{ eyebrow }}</div>
      <h1 class="pagehdr__title">{{ title }}</h1>
      <div v-if="sub" class="pagehdr__sub">{{ sub }}</div>
    </div>
    <div class="pagehdr__right">
      <slot name="right" />
    </div>
  </div>
</template>

<style scoped>
.pagehdr {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
  font-family: var(--font-sans);
}
.pagehdr__eyebrow {
  margin-bottom: 7px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--ink-400);
}
.pagehdr__title {
  margin: 0;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.6px;
  color: var(--text-primary);
}
.pagehdr__sub {
  margin-top: 6px;
  font-size: 14.5px;
  color: var(--ink-600);
}
.pagehdr__right {
  flex-shrink: 0;
}
</style>
